export const statusColorOption = {
  onlyEarly: '#00539A',
  Early: ' #00539A ',
  early: '#00539A',
  on_time: '#279B4E',
  ontime: '#279B4E',
  OnTime: '#279B4E',
  On_time: '#279B4E',
  'Ontime Trips': '#279B4E',
  'On Time': '#279B4E',
  Ontime: ' #279B4E',
  onlyOntime: '#279B4E',
  'Delayed Trips': '#C84031',
  Delayed: '#C84031',
  delayed: '#C84031',
  untracked: '#9D5E34',
  untracked_state: '#9D5E34',
  untracked_status: '#9D5E34',
  Unknown: '#9D5E34',
  unknown: '#9D5E34',
  at_stop: '#ED7201',
  'Untracked Status': '#9D5E34',
  'Untracked Trips': '#9D5E34',
  exceptions: '#D84343',
  exception: '#D84343',
  disconnected: '#46D843'
}
export const stateColorOption = {
  enroute: '#2a5491',
  'Enroute Trips': '#2a5491',
  at_unloading: '#A93E06',
  'At Unloading': '#A93E06',
  'Trips At Unloading': '#A93E06',
  completed: '#279B4E',
  Completed: '#279B4E',
  return_journey_completed: '#279B4E',
  in_transit: '#FDC500',
  'In Transit': '#FDC500',
  at_loading: '#D36638',
  'Trips At Loading': '#D36638',
  'At Loading': '#D36638',
  untracked: '#9D5E34',
  untracked_state: '#9D5E34',
  'Untracked State': '#9D5E34',
  untracked_status: '#9D5E34',
  Unknown: '#9D5E34',
  unknown: '#9D5E34',
  at_stop: '#ED7201',
  'At Stop': '#ED7201',
  'Untracked Status': '#9D5E34',
  'Untracked Trips': '#9D5E34',
  scheduled: '#0EB08E',
  at_pol: '#6A88F2',
  at_transshipment_port: '#3DD2E7',
  at_pot: '#3DD2E7',
  at_pod: '#27A5F9',
  disconnected: '#46D843'
}

export const summaryColorOption = {
  'Total Routes': '#2a5491',
  'Trips Count': '#007f7f',
  'Total Trips': '#007f7f',
  'Total Transporters': '#c2706f'
}

export const colorConstCommon = {
  normalText: '#727272',
  linkText: '#0391FF',
  background: '#F5F6F8',
  border: '#CECECE',
  pendingCount: '#E8B716',
  confirmedCount: '#417505',
  cancelledCount: '#E02020',
  pending: '#E8B716',
  confirmed: '#417505',
  completed: '#417505',
  cancelled: '#E02020',
  short_closed: '#E02020',
  reported: '#006491',
  exited: '#CECECE',
  placed: '#E8B716',
  approved: 'orange'
}

export const ColorsCommon = {
  darkLabelColor: '#333333',
  inputLabelColor: '#666666',
  inputSubLabelColor: '#9fa1a2',
  backgroundColor: '#f4f6f8',
  rightContainerBackgroundColor: '#ffffff',
  anchorColor: '#038AF1',
  orButtonColor: '#9b9b9b',
  orButtonEnableColor: '#4285f4',
  errorColor: 'red',
  kpiBackgroundColor: '#ffffff',
  chartLabelColor: '#212121',
  dropDownBackGroundColor: '#F5F5F5',
  subTextLabelColor: '#727272',
  infoIconColor: '#BBBBBB',
  dimensionBackgroundColor: '#EFEFEF'
}

export const severityColors = {
  low: 'rgb(105, 192, 255)',
  medium: 'rgba(250,140,22,1)',
  high: 'rgb(213, 0, 0)'
}

export const KPI_COLORS = {
  default: 'rgba(98, 90, 80, 1)',
  pending: ' rgb(66, 165, 245)',
  pending_vehicle_qty: ' rgb(66, 165, 245)',
  pending_tonnage_qty: ' rgb(66, 165, 245)',
  successfully_reported_vehicle_qty: ' rgb(255, 87, 34)',
  successfully_reported_tonnage_qty: ' rgb(255, 87, 34)',
  short_closed: 'rgb(149, 117, 205)',
  cancelled: ' rgb(240, 98, 146)',
  cancelled_vehicle_qty: 'rgb(240, 98, 146)',
  cancelled_tonnage_qty: 'rgb(240, 98, 146)',
  placed: ' rgb(156, 204, 101)',
  placed_vehicle_qty: ' rgb(102, 187, 106)',
  placed_tonnage_qty: ' rgb(102, 187, 106)',
  confirmed: 'rgb(38, 166, 154)',
  confirmed_vehicle_qty: 'rgb(38, 166, 154)',
  confirmed_tonnage_qty: ' rgb(38, 166, 154)',
  elapsed: 'rgb(255, 183, 77)',
  elapsed_vehicle_qty: 'rgb(255, 183, 77)',
  elapsed_tonnage_qty: 'rgb(255, 183, 77)',
  exited_vehicle_qty: 'rgb(149, 117, 205)',
  exited_tonnage_qty: 'rgb(149, 117, 205)',
  reported_vehicle_qty: 'rgb(239, 83, 80)',
  reported_tonnage_qty: 'rgb(239, 83, 80)',
  at_transit_jn: '',
  at_end_jn: '',
  at_start_jn: '',
  pick_up_executive_assigned: '',
  out_for_pickup: '',
  delivery_executive_assigned: '',
  out_for_delivery: '',
  delivered: '',
  'Total Delivered': '#279B4E',
  'Total Failed': '#C84031',
  Untracked: '#9D5E34',
  ...stateColorOption,
  ...statusColorOption
}

export const labelColor = '#727272'

export const valueColor = '#212121'

export const tripTabsBackground = '#FFFFFF'
export const modeBackground = '#DADADA'
export const dragColors = {
  isDragAccept: '#00e676',
  isDragReject: '#ff1744',
  isDragActive: '#2196f3',
  default: '#eeeeee'
}

export const tatActualColorsCommon = {
  less: { block: '#2FBA7E', text: '#326d54' },
  greater: { block: '#F64B4B', text: '#ad1f1f' },
  default: { block: '#F5A623', text: 'rgb(187, 117, 0)' }
}

export const poiTypeLoadingAltLoading = '#F7C764'

export const tripColors = {
  mapListGrid: '#E9ECF6',
  exceptionWrapper: '#fff',
  tripStatus: '#F3FFE5',
  tripMaterial: '#d6d2d2',
  tripTabs: tripTabsBackground
}

export const mentionStyleColors = {
  control: '#fff',
  highlighter: '#fff',
  multipleLine: { highlighter: '#fff' },
  suggestions: { list: 'white', item: '#cee4e5' }
}

export const intransitColors = {
  colors: [
    '#f08080',
    '#a0db8e',
    '#b5d8f6',
    '#237986',
    '#2a5491',
    '#0dea38',
    '#ff8bc9',
    '#b02f30',
    '#802F18',
    '#007f7f',
    '#ff7f50',
    '#c2706f',
    '#ffe4e1',
    '#f5f5dc',
    '#a0db8e',
    '#b5d8f6',
    '#237986',
    '#2a5491',
    '#0dea38',
    '#ff8bc9',
    '#b02f30',
    '#802F18',
    '#007f7f',
    '#ff7f50',
    '#c2706f',
    '#ffe4e1',
    '#f5f5dc',
    '#a0db8e',
    '#b5d8f6',
    '#237986',
    '#2a5491',
    '#0dea38',
    '#ff8bc9',
    '#b02f30',
    '#802F18',
    '#007f7f',
    '#ff7f50',
    '#c2706f',
    '#ffe4e1',
    '#f5f5dc',
    '#f08080',
    '#a0db8e',
    '#b5d8f6',
    '#237986',
    '#2a5491',
    '#0dea38',
    '#ff8bc9',
    '#b02f30',
    '#802F18',
    '#ff7f50',
    '#c2706f',
    '#ffe4e1',
    '#f5f5dc',
    '#2a5491',
    '#007f7f',
    '#ff7f50',
    '#c2706f',
    '#ffe4e1',
    '#f5f5dc',
    '#a0db8e',
    '#b5d8f6',
    '#237986',
    '#2a5491',
    '#0dea38',
    '#ff8bc9',
    '#b02f30',
    '#802F18',
    '#007f7f',
    '#ff7f50',
    '#c2706f',
    '#ffe4e1',
    '#f5f5dc',
    '#a0db8e',
    '#b5d8f6',
    '#237986',
    '#2a5491',
    '#0dea38',
    '#ff8bc9',
    '#b02f30',
    '#802F18',
    '#007f7f'
  ],
  circularProgress: {
    bad: '#FF2626',
    good: '#2FBA7E',
    other: '#F5A623'
  },
  tat: {
    count: {
      actual: '#2FBA7E',
      within: '#2FBA7E',
      above: '#F5A623',
      exception: '#FF2626'
    }
  },
  material: {
    concentrate: '#4A71F1',
    coal: '#9013FE',
    zinc: '#E23E8B',
    'zinc lead': '#E23E8B',
    lead: '#E23E8B',
    acid: '#DFDFDF',
    ore: '#795548',
    cathode: '#FFF59D',
    calcine: '#9CCC65',
    fg: '#7C4DFF',
    scrap: '#607D8B'
  },
  onTimeDelivery: {
    count: {
      onTime: '#2FBA7E',
      ...statusColorOption
    },
    chart: {
      green: 'linear-gradient(180deg, #2EB087 0%, rgba(23,208,129,0.4) 100%)',
      red:
        'linear-gradient(0deg, rgba(255,117,117,0.09) 0%, rgba(255,38,38,0.85) 100%)',
      onTime: 'linear-gradient(180deg, #2EB087 0%, rgba(23,208,129,0.4) 100%)',
      delayed:
        'linear-gradient(180deg, #FF9A0A 0%, rgba(255,209,92,0.39) 100%)',
      exception:
        'linear-gradient(0deg, rgba(255,117,117,0.09) 0%, rgba(255,38,38,0.85) 100%)',
      early: 'rgb(209,196,233)'
    }
  },
  chartGradient: {
    green: 'linear-gradient(180deg, #2EB087 0%, rgba(23,208,129,0.4) 100%)',
    red:
      'linear-gradient(0deg, rgba(255,117,117,0.09) 0%, rgba(255,38,38,0.85) 100%)'
  },
  pilferage: {
    chart: {
      potential:
        'linear-gradient(180deg, #FF9A0A 0%, rgba(255,209,92,0.39) 100%)',
      confirmed:
        'linear-gradient(180deg, rgba(255,117,117,0.09) 0%, rgba(255,38,38,0.85) 100%)'
    }
  },
  exceptions: {
    chart: {
      routeDeviation: '#F03B3B',
      overstoppageAtHalt: '#FF7326',
      unscheduledStoppage: '#C73030',
      gpsOffline: '#7B353E'
    }
  },
  inPlantVehicleIssues: {
    chart: {
      unregisteredDriver: '#F03B3B',
      breakdown: '#FF7326',
      exceedingTat: '#C73030'
    }
  },
  subFilterColors: {
    selectedFilterColor: 'rgb(38,150,190)',
    selectedFilterAlpha25Color: 'rgb(38,150,190,.25)',
    selectedFilterAlpha60Color: 'rgb(38,150,190,.60)',
    containerModal: 'rgb(76,88,112)',
    overlayColor: 'rgba(0, 0, 0, .45)',
    searchButtonBackGroundColor: 'rgb(48, 119, 181)',
    searchButtonColor: 'rgb(250,250,250)',
    searchButtonBoxShadowColor: 'rgb(48, 119, 181,.50)',
    searchTextColor: 'rgb(137,137,137)',

    darkColorTheme: 'rgb(33,44,64)',
    darkColor25Theme: 'rgb(33,44,64 ,0.25)',
    darkColor80Theme: 'rgb(33,44,64 ,0.80)',
    lightColorTheme: 'rgb(76,88,112)',
    tagColor: 'rgb(21,173,240)',
    selectedFilterBackGroundColor: 'rgb(26, 40, 71)'
  },
  process: {
    firstweight: 'rgb(121,134,203)',
    secondweight: 'rgb(77,182,172)',
    parkingin: 'rgb(174,213,129)',
    gatein: 'rgb(255,183,77)'
  },
  temperatureToolTip: {
    temperatureContent: {
      withinRange: '#009D32',
      outsideRange: '#C84031'
    },
    temperatureToolTipBackground: {
      withinRange: '#E2FFEA',
      outsideRange: '#FFE5E7'
    }
  }
}

export const colorsList = {
  colors: [
    '#f08080',
    '#a0db8e',
    '#b5d8f6',
    '#237986',
    '#2a5491',
    '#0dea38',
    '#ff8bc9',
    '#b02f30',
    '#802F18',
    '#007f7f',
    '#ff7f50',
    '#c2706f',
    '#ffe4e1',
    '#f5f5dc',
    '#a0db8e',
    '#b5d8f6',
    '#237986',
    '#2a5491',
    '#0dea38',
    '#ff8bc9',
    '#b02f30',
    '#802F18',
    '#007f7f',
    '#ff7f50',
    '#c2706f',
    '#ffe4e1',
    '#f5f5dc',
    '#a0db8e',
    '#b5d8f6',
    '#237986',
    '#2a5491',
    '#0dea38',
    '#ff8bc9',
    '#b02f30',
    '#802F18',
    '#007f7f',
    '#ff7f50',
    '#c2706f',
    '#ffe4e1',
    '#f5f5dc',
    '#f08080',
    '#a0db8e',
    '#b5d8f6',
    '#237986',
    '#2a5491',
    '#0dea38',
    '#ff8bc9',
    '#b02f30',
    '#802F18',
    '#ff7f50',
    '#c2706f',
    '#ffe4e1',
    '#f5f5dc',
    '#2a5491',
    '#007f7f',
    '#ff7f50',
    '#c2706f',
    '#ffe4e1',
    '#f5f5dc',
    '#a0db8e',
    '#b5d8f6',
    '#237986',
    '#2a5491',
    '#0dea38',
    '#ff8bc9',
    '#b02f30',
    '#802F18',
    '#007f7f',
    '#ff7f50',
    '#c2706f',
    '#ffe4e1',
    '#f5f5dc',
    '#a0db8e',
    '#b5d8f6',
    '#237986',
    '#2a5491',
    '#0dea38',
    '#ff8bc9',
    '#b02f30',
    '#802F18',
    '#007f7f'
  ]
}

export const escalationColors = {
  greaterThan: '#D32B2B',
  between: '#FD6F4C',
  lessThan: '#D7D7E4'
}

export const severityBackgroundColor = {
  low: '#E5F6FF',
  medium: '#FFF9E3',
  high: '#FFE5E7'
}

export const severityColor = {
  low: '#1276D3',
  medium: '#FDC500',
  high: '#C84031'
}

export const addNewUserCollaborationColors = {
  IssueLabelText: '#727272',
  IssueHeadingText: '#212121'
}
export const terminalView = {
  darkTheme: {
    bodyBgColor: '#161A24',
    textColor: '#dbe5f1',
    arrival: {
      row1: '#2D2D49',
      row2: '#42425B',
      header: '#1D1D2B',
      headerText: '#DBE5F1',
      paginationHeader: '#2D2D49',
      paginationText: '#DBE5F1',
      paginationTextHighlight: '#3588e8'
    },
    departure: {
      row1: '#372D2C',
      row2: '#4B4241',
      header: '#221D1D',
      headerText: '#DBE5F1',
      paginationHeader: '#372D2C',
      paginationText: '#DBE5F1',
      paginationTextHighlight: '#3588e8'
    },
    status: {
      delayed: '#C84031',
      early: '#FF7F50',
      on_time: '#34864F',
      untracked_status: '#4B4241'
    },
    dropDown: {
      color: '#F3F3F3',
      background: '#23252F',
      border: ' #212121',
      isFocused: {
        color: '#23252F',
        background: '#F3F3F3'
      }
    },
    timer: {
      background: '#23252f',
      color: '#f1f1f1'
    }
  }
}
